import { ChevronsUpDown } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgExpandArrow = mkIcon(ChevronsUpDown);